// The upload cap the server enforces on presign (core.webSubmissionMaxBytes).
export const MAX_UPLOAD_BYTES = 150 * 1024 * 1024;

// fileOK accepts only an mp3 or wav under the cap, so a bad file is refused
// before any request is made.
export function fileOK(file: File): boolean {
  const name = file.name.toLowerCase();
  return (name.endsWith(".mp3") || name.endsWith(".wav")) && file.size > 0 && file.size <= MAX_UPLOAD_BYTES;
}

// putFile PUTs the file to a presigned URL and reports progress. Its own
// module so tests can stand in for the network. Extra headers are whatever
// the signature covers — contest covers must send x-amz-tagging.
export function putFile(
  url: string,
  file: File,
  contentType: string,
  onProgress: (pct: number) => void,
  headers: Record<string, string> = {},
): Promise<boolean> {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url);
    const hdrs = { ...(contentType ? { "Content-Type": contentType } : {}), ...headers };
    for (const [k, v] of Object.entries(hdrs)) if (v) xhr.setRequestHeader(k, v);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => resolve(xhr.status >= 200 && xhr.status < 300);
    xhr.onerror = () => resolve(false);
    xhr.onabort = () => resolve(false);
    xhr.send(file);
  });
}
